var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('grid',_vm._b({ref:"grid",staticClass:"h-100"},'grid',_vm.gridConfig,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }